import api from "@services/api-service";
import queryParams from "@services/repository-service";

const store = {
  // ////////////////////////////////////////////
  // STATE
  // ////////////////////////////////////////////

  state: {
    loading: false,
    contratos: []
  },

  // ////////////////////////////////////////////
  // MUTATIONS
  // ////////////////////////////////////////////

  mutations: {},

  // ////////////////////////////////////////////
  // GETTERS
  // ////////////////////////////////////////////

  getters: {
    fetchParamsContratos: () => ({
      page,
      sortedBy,
      orderBy,
      status,
      cod,
      nome,
      associacao,
      entidade,
      parceiro,
      cpf,
      formaPagamento,
      criacao
    }) =>
      queryParams({
        page: page,
        relationships: [
          "status",
          "statusMotivo",
          "cliente",
          "associacao",
          "entidade",
          "parceiro",
          "usuario",
          "formaPagamento"
        ],
        where: [
          ["status.slug", "=", status],
          ["id", "=", cod],
          ["cliente.nome", "like", nome],
          ["cliente.cpf", "like", cpf],
          ["formaPagamento.id", "like", formaPagamento],
          ["associacao.id", "like", associacao],
          ["entidade.id", "like", entidade],
          ["parceiro.id", "like", parceiro],
          ["created_at", "between", criacao]
        ],
        sortedBy: sortedBy,
        orderBy: orderBy
      }),

    fetchContratos: () => async options =>
      await api().get(`contratos`, {
        params: store.getters.fetchParamsContratos()(options)
      }),

    fetchContratosAnalise: () => async () => {
      return await api().get(`contratos-analise-documentos`);
    },
    fetchMotivosErro: () => async anexoId => {
      return await api().get(`contratos-analise-documentos/motivos-reprova`, {
        params: { anexoId: anexoId }
      });
    },
    fetchDocumentosContrato: () => async contratoId => {
      return await api().get(`contrato/anexos`, {
        params: {
          ...queryParams({ relationships: ["contratoAnexoTipo"] }),
          contrato_id: contratoId
        }
      });
    },

    fetchTiposDocumentosContrato: () => async () => {
      let response = await api().get(`contrato-anexo-tipos`, {
        params: queryParams({
          where: [["ativo", "=", 1]]
        })
      });

      if (response.data.status) {
        return response.data.data;
      }

      return [];
    },

    excluirDocumentoContrato: () => async anexoId => {
      return await api().delete(`contrato/anexos/${anexoId}`);
    }
  },

  // ////////////////////////////////////////////
  // ACTIONS
  // ////////////////////////////////////////////

  actions: {}
};

export default store;
